<template>
  <div
    id="text-block"
    class="text-block-section"
  >
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div
            class="content"
            v-html="section.content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stripBlockTags from '@/utils/strip-block-tags';

export default {
  name: 'BannerLikeSection',

  props: {
    section: { type: Object, required: true }
  },

  methods: {
    stripBlockTags
  }
};
</script>

<style lang="scss" scoped>
.text-block-section {
  background-image: none;
  background-color: #efefef;
  padding: 0;

  .container {
    max-width: 100%;
    padding: 40px 0 0 !important;

    @media screen and (min-width: $breakpoint-md) {
      max-width: 1120px;
      padding-left: 24px;
      padding-right: 24px;
      padding-bottom: 30px !important;
    }
  }

  .row {
    margin-left: 0;
    margin-right: 0;

    .col-12 {
      margin: 0;
      width: 100%;
    }
  }
}
</style>
